
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30311',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30311",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54622",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8029",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11487",
  "I18n": "static-7.1630",
  "quartz": "static-1.7052",
  "quartz-config": "static-1.830",
  "quartz-core": "static-1.6271",
  "react-dlb": "static-1.79",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.796",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54609",
  "feedback-utils": "static-1.54613",
  "forms-embed-utils-lib": "static-1.4479",
  "forms-utils-lib": "static-1.12618",
  "foundations-assets": "static-1.4882",
  "foundations-components": "static-1.7969",
  "foundations-theming": "static-1.4435",
  "hub-http": "static-1.6237",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11794",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3927",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16687",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5355",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.487",
  "tinymce-plugins": "static-1.57538",
  "transmute": "static-2.85",
  "ui-images": "static-2.1158",
  "UIComponents": "static-3.8433",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3410",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3329",
  "quartz-webpack": "static-1.3276",
  "foundations-theming-specialty": "static-1.2151",
  "property-description-translator": "static-1.3859",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3140",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4343",
  "jasmine-runner": "static-1.6479",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4662",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.727",
  "quartz-head": "static-1.717",
  "quartz-i18n": "static-1.727",
  "quartz-routing": "static-1.482",
  "quartz-test": "static-1.727",
  "quartz-tracking": "static-1.431",
  "ui-fonts": "static-1.749",
  "usage-tracker-container": "static-1.7351",
  "usage-tracker-core": "static-1.7211",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7262",
  "reference-resolvers": "static-1.8186",
  "sanitize-text": "static-1.8157",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10381",
  "sanitize": "static-1.4492",
  "outpost": "static-1.4197",
  "rpc-client-utils": "static-1.4668",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4238",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9440",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.28",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1996",
  "bend-plugin-foundations-theming": "static-1.2918",
  "foundations-theming-base": "static-1.3420",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.91",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "ai-components-ui-library": "static-1.9029",
  "atom": "static-1.5088",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7777",
  "ContentUtils": "static-1.68422",
  "data-token-picker": "static-1.16437",
  "file-manager-components": "static-1.23676",
  "FileManagerCore": "static-1.39175",
  "FileManagerLib": "static-1.39316",
  "frontend-preferences-client": "static-1.7943",
  "hub-http-contrib": "static-1.3058",
  "interframe": "static-3.4775",
  "layout-dnd-components": "static-1.12477",
  "layout-dnd-utils": "static-1.11452",
  "property-translator": "static-1.5415",
  "react-codemirror": "static-1.10642",
  "react-colorpicker": "static-2.10222",
  "reference-resolvers-lite": "static-1.8110",
  "rich-text-lib": "static-1.19863",
  "tinymce-data": "static-1.40509",
  "tinymce-themes": "static-1.56394",
  "ui-addon-emoji-picker": "static-1.9903",
  "ui-addon-sales-email": "static-1.5226",
  "ui-brand-identity-lib": "static-1.15360",
  "bender-build-tools": "static-1.3215",
  "hub-http-shared-msw-handlers": "static-1.10009",
  "hubspotter-http-shared-msw-handlers": "static-1.10007",
  "usage-tracker-session-replay": "static-1.5047",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.78",
  "chirp-fetch": "static-1.1903",
  "chatspot-core": "static-1.21407",
  "copilot-toolkit": "static-1.11182",
  "customer-data-objects-ui-components": "static-1.13044",
  "data-fetching-client": "static-1.9683",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4777",
  "ui-addon-video-player": "static-1.8718",
  "ui-coaching-tips": "static-1.28616",
  "usage-tracker": "static-1.7361",
  "cms-field-types": "static-1.4828",
  "content-icons-ui": "static-1.2231",
  "integrations-lib": "static-1.16209",
  "customer-data-objects": "static-1.7685",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4667",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4169",
  "ui-addon-iframeable": "static-1.9073",
  "video-components-external": "static-1.11336",
  "video-data-lib": "static-1.34994",
  "audio-components": "static-1.5939",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29327",
  "FileManagerImages": "static-1.36827",
  "foundations-components-legacy": "static-1.994",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.8997",
  "urlinator": "static-1.4552",
  "video-components": "static-1.13339",
  "video-embed": "static-1.35828",
  "ts-schema": "static-1.4090",
  "ContentData": "static-1.68497",
  "layout-data-lib": "static-1.9777",
  "react-dnd-compat": "static-1.4630",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1557",
  "external-options-client-types": "static-1.4169",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6900",
  "hs-promise-utils": "static-1.5606",
  "inbound-db-properties-service-client": "static-1.3856",
  "NamespacedHubStyle": "static-2.9069",
  "growth-onboarding-confetti": "static-1.3082",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11164",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5561",
  "magpie-types": "static-1.5021",
  "simple-logging-lib": "static-1.3066",
  "avatar-components": "static-1.2513",
  "customer-data-ui-utilities": "static-1.9842",
  "growth-onboarding-feedback-components": "static-1.6596",
  "flux-actions": "static-1.340",
  "hubspot-apollo-client": "static-1.4895",
  "integrations-error-boundary-lib": "static-1.13624",
  "integrations-tracking-lib": "static-1.5617",
  "laboratory-lib": "static-3.7171",
  "native-integrations-shared-strings": "static-1.7797",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10180",
  "unified-auth": "static-1.511",
  "navigation-messaging": "static-1.7418",
  "content-media-composition-data-lib": "static-1.12381",
  "content-media-compositions": "static-2.16388",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18956",
  "unified-auth-core-lib": "static-1.793",
  "social-insights-client-types": "static-1.22176",
  "advanced-menus-core": "static-1.15153",
  "advanced-menus-lib": "static-1.12092",
  "ExportDialog": "static-6.10402",
  "ui-memberships-settings-lib": "static-1.34101",
  "conditional-properties-service-client": "static-1.3807",
  "crm-pipelines-api-client-types": "static-1.4149",
  "fdsr-migration-layer": "static-1.19",
  "framework-builder-read-service-client": "static-1.4015",
  "framework-data-schema-quick-fetch": "static-1.6805",
  "inbound-db-meta-service-client": "static-1.3596",
  "multi-currency-client-types": "static-1.3701",
  "persist-promise": "static-1.3714",
  "foundations-components-test-utils": "static-1.5452",
  "reactive-lib": "static-1.739",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.354",
  "universal-page-editor-lib": "static-1.3029",
  "google-sheets-integration-lib": "static-1.297",
  "microsoft-drive-integration-lib": "static-1.425",
  "slack-ui-library": "static-1.10408",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3746",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15152",
  "simple-menus-lib": "static-1.16669",
  "crm-record-cards-service-types": "static-1.3607",
  "location-customization-utils-lib": "static-1.9320",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30311",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54622",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8029",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11487",
  "I18n": "/I18n/static-7.1630",
  "quartz": "/quartz/static-1.7052",
  "quartz-config": "/quartz-config/static-1.830",
  "quartz-core": "/quartz-core/static-1.6271",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.796",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54609",
  "feedback-utils": "/feedback-utils/static-1.54613",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4479",
  "forms-utils-lib": "/forms-utils-lib/static-1.12618",
  "foundations-assets": "/foundations-assets/static-1.4882",
  "foundations-components": "/foundations-components/static-1.7969",
  "foundations-theming": "/foundations-theming/static-1.4435",
  "hub-http": "/hub-http/static-1.6237",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11794",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3927",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16687",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5355",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tinymce-plugins": "/tinymce-plugins/static-1.57538",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1158",
  "UIComponents": "/UIComponents/static-3.8433",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3410",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3329",
  "quartz-webpack": "/quartz-webpack/static-1.3276",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2151",
  "property-description-translator": "/property-description-translator/static-1.3859",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3140",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4343",
  "jasmine-runner": "/jasmine-runner/static-1.6479",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4662",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.727",
  "quartz-head": "/quartz-head/static-1.717",
  "quartz-i18n": "/quartz-i18n/static-1.727",
  "quartz-routing": "/quartz-routing/static-1.482",
  "quartz-test": "/quartz-test/static-1.727",
  "quartz-tracking": "/quartz-tracking/static-1.431",
  "ui-fonts": "/ui-fonts/static-1.749",
  "usage-tracker-container": "/usage-tracker-container/static-1.7351",
  "usage-tracker-core": "/usage-tracker-core/static-1.7211",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7262",
  "reference-resolvers": "/reference-resolvers/static-1.8186",
  "sanitize-text": "/sanitize-text/static-1.8157",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10381",
  "sanitize": "/sanitize/static-1.4492",
  "outpost": "/outpost/static-1.4197",
  "rpc-client-utils": "/rpc-client-utils/static-1.4668",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4238",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9440",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.28",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1996",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2918",
  "foundations-theming-base": "/foundations-theming-base/static-1.3420",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.91",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9029",
  "atom": "/atom/static-1.5088",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7777",
  "ContentUtils": "/ContentUtils/static-1.68422",
  "data-token-picker": "/data-token-picker/static-1.16437",
  "file-manager-components": "/file-manager-components/static-1.23676",
  "FileManagerCore": "/FileManagerCore/static-1.39175",
  "FileManagerLib": "/FileManagerLib/static-1.39316",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7943",
  "hub-http-contrib": "/hub-http-contrib/static-1.3058",
  "interframe": "/interframe/static-3.4775",
  "layout-dnd-components": "/layout-dnd-components/static-1.12477",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11452",
  "property-translator": "/property-translator/static-1.5415",
  "react-codemirror": "/react-codemirror/static-1.10642",
  "react-colorpicker": "/react-colorpicker/static-2.10222",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8110",
  "rich-text-lib": "/rich-text-lib/static-1.19863",
  "tinymce-data": "/tinymce-data/static-1.40509",
  "tinymce-themes": "/tinymce-themes/static-1.56394",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9903",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5226",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15360",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10009",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10007",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5047",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.78",
  "chirp-fetch": "/chirp-fetch/static-1.1903",
  "chatspot-core": "/chatspot-core/static-1.21407",
  "copilot-toolkit": "/copilot-toolkit/static-1.11182",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13044",
  "data-fetching-client": "/data-fetching-client/static-1.9683",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4777",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8718",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28616",
  "usage-tracker": "/usage-tracker/static-1.7361",
  "cms-field-types": "/cms-field-types/static-1.4828",
  "content-icons-ui": "/content-icons-ui/static-1.2231",
  "integrations-lib": "/integrations-lib/static-1.16209",
  "customer-data-objects": "/customer-data-objects/static-1.7685",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4667",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4169",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9073",
  "video-components-external": "/video-components-external/static-1.11336",
  "video-data-lib": "/video-data-lib/static-1.34994",
  "audio-components": "/audio-components/static-1.5939",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29327",
  "FileManagerImages": "/FileManagerImages/static-1.36827",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.994",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.8997",
  "urlinator": "/urlinator/static-1.4552",
  "video-components": "/video-components/static-1.13339",
  "video-embed": "/video-embed/static-1.35828",
  "ts-schema": "/ts-schema/static-1.4090",
  "ContentData": "/ContentData/static-1.68497",
  "layout-data-lib": "/layout-data-lib/static-1.9777",
  "react-dnd-compat": "/react-dnd-compat/static-1.4630",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1557",
  "external-options-client-types": "/external-options-client-types/static-1.4169",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6900",
  "hs-promise-utils": "/hs-promise-utils/static-1.5606",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3856",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9069",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3082",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11164",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5561",
  "magpie-types": "/magpie-types/static-1.5021",
  "simple-logging-lib": "/simple-logging-lib/static-1.3066",
  "avatar-components": "/avatar-components/static-1.2513",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9842",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6596",
  "flux-actions": "/flux-actions/static-1.340",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4895",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13624",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5617",
  "laboratory-lib": "/laboratory-lib/static-3.7171",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7797",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10180",
  "unified-auth": "/unified-auth/static-1.511",
  "navigation-messaging": "/navigation-messaging/static-1.7418",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12381",
  "content-media-compositions": "/content-media-compositions/static-2.16388",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18956",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.793",
  "social-insights-client-types": "/social-insights-client-types/static-1.22176",
  "advanced-menus-core": "/advanced-menus-core/static-1.15153",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12092",
  "ExportDialog": "/ExportDialog/static-6.10402",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34101",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3807",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4149",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.19",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4015",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6805",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3596",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3701",
  "persist-promise": "/persist-promise/static-1.3714",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5452",
  "reactive-lib": "/reactive-lib/static-1.739",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.354",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3029",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.297",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.425",
  "slack-ui-library": "/slack-ui-library/static-1.10408",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3746",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15152",
  "simple-menus-lib": "/simple-menus-lib/static-1.16669",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3607",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9320",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
